import tw, { styled } from "twin.macro";

export const Wrapper = styled.div`
	${tw`p-2 bg-white w-full flex flex-col items-center container`}
`;
